import maIsohService from "../maIsohService/maIsohService";

export default angular.module('carPartsDimensions', [
	maIsohService
])

	.service('carPartsDimensions', function(maIsoh) {
		this.dimensions = [];
		this.lastSync = '1.1.1970';

		/**
		 * Set default storage and set values
		 */

			let db =  JSON.parse(localStorage.getItem('carPartsDimensions'));   //*@include ../../../carDimensions.json

			if(db != null) {
				this.dimensions = typeof db.dimensions == "undefined" ? this.dimensions : db.dimensions;
				this.lastSync = typeof db.lastSync == "undefined" ? this.lastSync : db.lastSync;
			} else {
				db = {};
			}

		this.setDimensions = (dimensions) => {
			this.dimensions = angular.copy(dimensions);

				db.dimensions = this.dimensions;
				localStorage.setItem('carPartsDimensions', JSON.stringify(db));
		};

		this.setLastSync = (date) => {
			this.lastSync = date;
				db.lastSync = this.lastSync;
				localStorage.setItem('carPartsDimensions', JSON.stringify(db));
		};

		this.getDimensions = () => {
			return angular.copy(this.dimensions);
		};

		this.getLastSync = () => {
			return angular.copy(this.lastSync);
		};

		this.markLastSync = () => {
			let now = new Date();
			this.setLastSync(now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear());
		};

		this.getItemByCode = (code) => {
			let found = this.dimensions.filter((item) => {
				return item.kod == code;
			});

			if (found.length > 0) {
				return found[0];
			} else {
				return null;
			}
		};

		this.checkDimensions = () => {
			if(this.dimensions.length < 1) {
				this.loadCarPartsDimensions();
			}
		};

		/**
		 * Load car parts dimensions from server
		 */
		this.loadCarPartsDimensions = () => {
			maIsoh.loadCarPartsDimensions(this.getLastSync()).then((result) => {
				if (angular.isDefined(result.json.casti.item)) {
					this.setDimensions(result.json.casti.item);
					this.markLastSync();
				}
			}).catch((error) => {
				console.error(error.message);
			})
		};
	}).directive('carPartsSelector', function() {
		return {
			template: `
				<button class="btn btn-{{ctrl.btnClass}}" uib-tooltip="{{ctrl.tooltip}}" ng-click="ctrl.openSelector()"><i class="fa fa-comment"></i></button>`,
			restrict: 'E',
			scope: {},
			replace: true,
			bindToController: {
				selectTo: '=',
				btnClass: '<',
				tooltip: '<',
				onSelect: '<'
			},
			controller: function(ngDialog, $scope, $timeout) {
				if (angular.isUndefined(this.tooltip)) {
					this.tooltip = 'Vybrat z číselníku';
				}

				if (angular.isUndefined(this.btnClass)) {
					this.btnClass = 'warning';
				}

				/**
				 * Open modal for changing password
				 */
				this.openSelector = () => {
					ngDialog.open({
						template: 'services/carPartsDimensions/selector.tpl.html',
						controller: function($scope, carPartsDimensions) {
							this.carPartsDimensions = carPartsDimensions.getDimensions();

							this.select = () => {
								if (angular.isDefined(this.selected)) {
									$scope.closeThisDialog({value: this.selected});
								} else {
									$scope.closeThisDialog(false);
								}
							};
						},
						controllerAs: 'ctrl',
						name: 'carPartsSelectorDialog'
					}).closePromise.then((response) => {
						if (angular.isDefined(response.value.value)) {
							this.selectTo = response.value.value;
							if (angular.isFunction(this.onSelect)) {
								this.onSelect(response.value.value);
							}
						}
					});
				};
			},
			controllerAs: 'ctrl'
		};
	}).name;



// WEBPACK FOOTER //
// build/services/carPartsDimensions/carPartsDimensions.js